
import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';
import linkedinLoginAPI from './api';


export const GET_TOKEN = 'advaice/linkedin/GET_TOKEN';
export const GET_TOKEN_SUCCESS = 'advaice/linkedin/GET_TOKEN_SUCCESS';
export const GET_TOKEN_ERROR = 'advaice/linkedin/GET_TOKEN_ERROR';

const initialState = {
  status: INIT,
  accessToken: {},
};
export const linkedinStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_TOKEN: {
      return {
        ...state,
        status: LOADING,
      };
    }
    case GET_TOKEN_SUCCESS: {
      return {
        ...state,
        status: SUCCESS,
        accessToken: action.payload,
      };
    }
    case GET_TOKEN_ERROR: {
      return {
        ...state,
        status: ERROR,
        accessToken: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const getToken = data => ({
  type: GET_TOKEN,
  payload: data,
});

export const getTokenObservable = (store, requestData) =>
  Observable.fromPromise(linkedinLoginAPI(requestData))
    .map(data => ({
      type: GET_TOKEN_SUCCESS,
      payload: data,

    }))
    .catch(err =>
      Observable.of({
        type: GET_TOKEN_ERROR,
        payload: err,
      }));

export const getTokenLinkedinEpic = (action$, store) =>
  action$.ofType(GET_TOKEN).flatMap(action => getTokenObservable(store, action.payload));

export const linkedinEpic = combineEpics(getTokenLinkedinEpic);



// WEBPACK FOOTER //
// ./src/reducers/linkedin/duck.js